<template>
  <div class="search-result">
    <div class="search-detail">
      <h3>
        <span>搜索结果</span><p>搜索到广告产品信息&nbsp;<span>{{courseTotal}}</span>&nbsp;条：</p>
      </h3>
      <div v-if="courseTotal > 0">
        <ul v-if="courseList.length > 0">
          <li v-for="(item,index) in courseList" :key="index">
            <div class="title" @click="toDetail(item)" v-html="item.courseName"></div>
          </li>
        </ul>
        <div class="pagination">
          <a-pagination 
            :total="courseTotal" 
            :itemRender="itemRender" 
            @change="onChange" 
            :current="page"
            :pageSize="limit"
          />  
        </div>
      </div>
      <div v-else>
        <ul>
          <li>
            <div class="content">很抱歉，没有搜索到与"<span style="color:#f70">{{searchFailedWord}}</span>"相关的信息，要不您换个关键词我再帮您找找看。</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {Pagination} from 'ant-design-vue'
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {

    }
  },
  components:{
    'a-pagination':Pagination
  },
  created() {
    this.getCourseList()
  },
  watch:{
    linkCargoryId(val) {
      this.getCourseList()
    }
  },
  computed: {
    ...mapState('adwords',['courseTotal', 'courseList', 'searchWord', 'linkCargoryId', 'page', 'limit', 'searchFailedWord'])
  },
  methods:{
    ...mapActions('adwords',['queryCourseList']),
    async getCourseList() {
      let params = {}
      this.linkCargoryId && (params['pojo.linkCargoryId'] = this.linkCargoryId)
      this.searchWord && (params['pojo.courseName'] = this.searchWord)
      await this.queryCourseList(params)
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a class="pagePN"><span class="triangleLeft"></span>上一页</a>;
      } else if (type === 'next') {
        return <a class="pagePN">下一页<span class="triangleRight"></span></a>;
      }
      return originalElement
    },
    onChange (current, pagesize) {
      this.$store.commit('adwords/setMutations', {data:current,nameSpace:'page'})
      this.$store.commit('adwords/setMutations', {data:pagesize,nameSpace:'limit'})
      this.getCourseList()
    },
    // 进广告产品详情页
    toDetail(item) {
      this.$router.push({name:'adwordsDetail', query: {id: item.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
$size-normal: 14px;
$color-primary: #1C7AE5;
$color-text-secondary: #999999;
$color-text-primary: #333333;
.search-result {
  .ant-pagination  {
    float: right;
    padding-right: 20px;

    .ant-pagination-total-text {
      order: -2;
      font-size: $size-normal;
      color: $color-text-primary;
      letter-spacing: 0;  
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      background: #FFFFFF;
      border: 1px solid #DBDBDB ;
      width: 64px;
      height: 28px;
      line-height: 28px;
      font-size: 12px;
      color: #CCCCCC;
      letter-spacing: 0;
      text-align: center;
      border: 1px solid #ccc;
      border-radius: 0; 
      margin-right: 10px;
    }

    .ant-pagination-item  {
      background: #FFFFFF;
      border: 1px solid #DBDBDB;
      height: 28px;
      line-height: 28px;
      color: $color-text-secondary;
      letter-spacing: 0;
      font-size: $size-normal;
      letter-spacing: 0;
      text-align: center;
      border-radius: 0;
      margin-right: 5px;
      text-align: center;
    }

    .ant-pagination-item-active {
      font-size: $size-normal;
      letter-spacing: 0;
      text-align: center;
      border: 0;
      border: 1px solid $color-primary;
    }

    .ant-pagination-options {
      order: -1;
      border-radius: 0;
      flex: 1;

      .ant-select-selection {
        border-radius: 0;
      }
    }

    .ant-pagination-disabled  {
      .pagePN:hover {
        .triangleLeft {
          border-right: 5px solid #cccccc !important;
        }

        .triangleRight {
          border-left: 5px solid #cccccc !important;
        }
      }
    }

    .pagePN:hover {
      .triangleLeft {
        border-right: 5px solid $color-primary !important;
      }

      .triangleRight {
        border-left: 5px solid $color-primary !important;
      }
    }

    .triangleLeft {
      margin-right: 4px;
      display: inline-block;
      position: relative;
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-right: 5px solid #cccccc;
    }

    .triangleRight {
      margin-left: 4px;
      display: inline-block;
      position: relative;
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 5px solid #cccccc;
    }

    .ant-pagination-options-quick-jumper {
      input {
        border-radius: 0;
        height: 28px;
      }
    }
  }
}
.search-result {
  padding-bottom: 15px;
  text-align: left;
  .search-detail {
    min-height: calc(100vh - 290px);
    background-color: #fff;
    padding: 20px;
    >h3 {
      position: relative;
      display: flex;
      padding-left: 8px;
      align-items: center;
      >span {
        font-size: 16px;
        color: #333333;
        padding-right: 10px;
      }
      >p {
        font-size: 14px;
        color: #666666;
        span {
          color: #FF3A00;
        }
      }
      &::before {
        content: "";
        position: absolute;
        left: 0;
        height: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        background: #1C7AE5;
      }
    }
    ul {
      margin-top: 9px;
      li {
        padding: 20px 14px;
        border-bottom: 1px dashed #EEEEEE;
        .title {
          line-height: 20px;
          position: relative;
          cursor: pointer;
          &:hover {
            color: #116CD0;
          }
          &:before {
            content: "";
            position: absolute;
            left: -14px;
            top: 50%;
            width: 4px;
            height: 4px;
            background: #DDDDDD;
            border-radius: 4px;
            transform: translateY(-50%);
          }
        }

        .titleS {
          color: #116CD0;
        }

        .titleS /deep/ b {
          color: #FF3A00;
        } 

        .content {
          font-size: 13px;
          color: #666666;
          padding-top: 9px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          height: 28px;   
        }
        .content /deep/ b {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: #FF3A00;
        }   
        .content /deep/ p {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }  
        .content /deep/ img {
          display: none;
        }  
      }
  }
    .pagination {
      padding-top: 11px;
      height: 60px;
    }
  }
}
</style>


